import React from 'react';
import { UnifiedDataTable } from './index';
import { UDCTableContainer } from './UDCTable.styles';

import { ColDef, GridOptions, GridReadyEvent, FilterChangedEvent } from '@ag-grid-community/core';

interface UDCTableProps<T = unknown> {
  columnDefs: ColDef<T>[];
  rowData?: T[];
  gridOptions?: GridOptions<T>;
  onGridReady?: (params: GridReadyEvent<T>) => void;
  onFilterChanged?: (event: FilterChangedEvent<T>) => void;
  locale?: string;
  timezone?: string;
  uidPrefix?: string;
  headerPanel?: React.ReactNode;
  footerPanel?: React.ReactNode;
}

const UDCTable = <T = unknown,>({
  columnDefs,
  rowData,
  gridOptions,
  onGridReady,
  onFilterChanged,
  locale = 'en-US',
  timezone = 'Asia/Kolkata',
  uidPrefix = 'udc-table',
  headerPanel,
  footerPanel,
}: UDCTableProps<T>) => {
  return (
    <UDCTableContainer>
      <UnifiedDataTable
        uidPrefix={uidPrefix}
        locale={locale}
        timezone={timezone}
        columnDefs={columnDefs}
        rowData={rowData}
        gridOptions={gridOptions}
        onGridReady={onGridReady}
        onFilterChanged={onFilterChanged}
        headerPanel={headerPanel}
        footerPanel={footerPanel}
      />
    </UDCTableContainer>
  );
};

export default UDCTable;
